import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=38afa62d&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=38afa62d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afa62d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38afa62d')) {
      api.createRecord('38afa62d', component.options)
    } else {
      api.reload('38afa62d', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=38afa62d&scoped=true&", function () {
      api.rerender('38afa62d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/Notification.vue"
export default component.exports